export const CLIENT_DEVICE_ID_STORAGE_KEY = "uzdpart360.client_device_id";

export function persistClientDeviceId(value, storage = window.localStorage) {
  const normalized = typeof value === "string" ? value.trim() : "";
  if (normalized) storage.setItem(CLIENT_DEVICE_ID_STORAGE_KEY, normalized);
  return normalized;
}

export function getOrCreateClientDeviceId(
  storage = window.localStorage,
  cryptoApi = window.crypto,
) {
  const existing = storage.getItem(CLIENT_DEVICE_ID_STORAGE_KEY)?.trim();
  if (existing) return existing;
  if (typeof cryptoApi?.randomUUID !== "function") {
    throw new Error("This browser cannot create a secure device identifier.");
  }
  return persistClientDeviceId(cryptoApi.randomUUID(), storage);
}

function detectBrowser(userAgent) {
  if (/Edg\//i.test(userAgent)) return "Edge";
  if (/OPR\//i.test(userAgent)) return "Opera";
  if (/Firefox\//i.test(userAgent)) return "Firefox";
  if (/Chrome\//i.test(userAgent)) return "Chrome";
  if (/Safari\//i.test(userAgent) && /Version\//i.test(userAgent)) return "Safari";
  return "Browser";
}

function detectPlatform(userAgent, navigatorApi) {
  const reported = navigatorApi?.userAgentData?.platform || navigatorApi?.platform;
  if (reported && !/^unknown$/i.test(reported)) return reported;
  if (/Windows/i.test(userAgent)) return "Windows";
  if (/Android/i.test(userAgent)) return "Android";
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
  if (/Mac OS/i.test(userAgent)) return "macOS";
  if (/Linux/i.test(userAgent)) return "Linux";
  return "Unknown platform";
}

export function describeClientDevice(navigatorApi = window.navigator) {
  const userAgent = navigatorApi?.userAgent || "";
  const device_browser = detectBrowser(userAgent);
  const device_platform = detectPlatform(userAgent, navigatorApi);
  const device_type = /iPad|Tablet/i.test(userAgent)
    ? "tablet"
    : /Android|iPhone|iPod|Mobile/i.test(userAgent)
      ? "mobile"
      : "desktop";

  return {
    device_name: `${device_browser} on ${device_platform}`,
    device_type,
    device_platform,
    device_browser,
  };
}
